import script from "./RuleInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./RuleInfoModal.vue?vue&type=style&index=0&id=ef5d3162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef5d3162"]])

export default __exports__